import { render, staticRenderFns } from "./IconDocumentRemoveSolid.vue?vue&type=template&id=3372f4ce"
import script from "./IconDocumentRemoveSolid.vue?vue&type=script&lang=js"
export * from "./IconDocumentRemoveSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports